import PageSkeleton from "../common/PageSkeleton";
import PageContainer from "../common/PageContainer";

const Information = () => (
  <PageSkeleton>
    <PageContainer>coming soon!</PageContainer>
  </PageSkeleton>
);

export default Information;
